import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[roblexUpperCase]'
})
export class UpperCaseDirective {
    @Input('roblexUpperCase') status = true;
    constructor(public el: ElementRef, private control: NgControl) {}

    @HostListener('input') onEvent() {
        const upper = this.el.nativeElement.value.toUpperCase();
        if (this.status) {
          this.control.control.setValue(upper);
        }
    }
}
